export const trianglePoints = (width: number, height: number) => `0,${height} ${width / 2},0 ${width},${height}`;
